import React from "react";
import { Route, Routes } from "react-router-dom";

import ReportMain from "./ReportMain";

import TscViewDetailsMain from "./TscViewDetailsMain";
import OaViewDetailMain from "./OaViewDetailMain";

type Props = {};

const ReportRoute = (props: Props) => {
  return (
    <Routes>
      <Route index element={<ReportMain />} />
      <Route path={"/view/tsc/:id"} element={<TscViewDetailsMain />} />
      <Route path={"/view/oa/:id"} element={<OaViewDetailMain />} />
    </Routes>
  );
};

export default ReportRoute;
